import React from 'react';
import { FieldTextArea, FieldTextAreaProps } from '@spotify-internal/anchor-ds';
import { FieldController, HookFormProps } from 'client/shared/FieldController';

type ControlledFieldTextAreaProps = HookFormProps &
  Omit<FieldTextAreaProps, 'length'>;

export const ControlledFieldTextArea = (
  props: ControlledFieldTextAreaProps
) => (
  <FieldController<FieldTextAreaProps, HTMLTextAreaElement>
    {...props}
    as={FieldTextArea}
  />
);
